import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4l4 16l4 -14l4 14l4 -16","key":"svg-0"}]]

const IconLetterW = createReactComponent('outline', 'letter-w', 'LetterW', __iconNode);

export default IconLetterW;